import React from 'react';
import PropTypes from 'prop-types';

function DownArrow({ active, activeColor, color }) {
  return (
    <path
      d="M201.53 268.103H180.554C176.686 268.103 173.549 264.967 173.549 261.098V242.767C173.549 240.91 174.287 239.128 175.601 237.814L185.767 227.648C188.503 224.912 192.939 224.912 195.674 227.648L206.176 238.15C207.461 239.434 208.196 241.167 208.227 242.984L208.534 260.979C208.601 264.894 205.445 268.103 201.53 268.103Z"
      fill={active ? activeColor : color}
    />
  );
}

DownArrow.propTypes = {
  active: PropTypes.bool,
  activeColor: PropTypes.string,
  color: PropTypes.string,
};

DownArrow.defaultProps = {
  active: false,
  activeColor: '#FFFFFF',
  color: '#4F535E',
};

export default DownArrow;
